import React, { FunctionComponent } from 'react';
import { LoginModal } from '../../organisms/loginModal';
import { RegisterModal } from '../../organisms/registerModal';

type Props = {
  embedUrl: string;
  isLoggedIn: boolean;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  isLoginModalOpen: boolean;
  isRegisterModalOpen: boolean;
  redirectUrl: string;
  isRecruitmentOrEventOrTvOrCompanyPath: () => boolean;
  handleToggleLoginModal: () => void;
  handleToggleRegisterModal: () => void;
  handleChangeModal: (from: 'login' | 'register') => void;
  lineIcon: string;
};

export const Presentation: FunctionComponent<Props> = ({
  embedUrl,
  isLoggedIn,
  onClick,
  isLoginModalOpen,
  isRegisterModalOpen,
  redirectUrl,
  isRecruitmentOrEventOrTvOrCompanyPath,
  handleToggleLoginModal,
  handleToggleRegisterModal,
  handleChangeModal,
  lineIcon
}) => {
  return (
    <>
      <div
        className="tv-content-top-youtube"
        onClick={onClick}
      >
        <iframe
          className="tv-content-top-youtube-iframe"
          src={embedUrl}
          style={{
            border: '0',
            ...(isLoggedIn ? {} : { pointerEvents: 'none' })
          }}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
      <LoginModal
        isModalOpen={isLoginModalOpen}
        redirectUrl={redirectUrl}
        fromButton="tv"
        handleToggleLoginModal={handleToggleLoginModal}
        handleChangeModal={handleChangeModal}
        lineIcon={lineIcon}
      />
      <RegisterModal
        isModalOpen={isRegisterModalOpen}
        redirectUrl={redirectUrl}
        isRequestPathRecruitmentOrEventOrTvOrFollow={isRecruitmentOrEventOrTvOrCompanyPath()}
        isCarefully={false}
        handleToggleRegisterModal={handleToggleRegisterModal}
        handleChangeModal={handleChangeModal}
        lineIcon={lineIcon}
      />
    </>
  );
};
